// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--zSTc7","image":"_0fce717cdb--image--uPYxM","text":"_0fce717cdb--text--OSN6e"};